import React, { Component } from "react";
import { Translate } from "react-redux-i18n";
import iphoneMockUp from "../../../styles/images/ceme/mobile.png";
import GOOGLE from "../../../styles/images/google.png";
import APPLE from "../../../styles/images/apple.png";
import "../../../styles/components/ceme/sections/Card.scss";
import {requestMetaConversionAPI} from '../../utils/Utils'

class Card extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div id="card">
        <div className="content-section">
          <div className="content">
            <div className="item top">
              <div className="title">ADESÃO</div>
              <div className="sub-title">CARREGAMENTO SEM COMPLICAÇÕES</div>
            </div>
            <div className="item left-side">
              <img src={iphoneMockUp} alt="EVIO Card" />
            </div>
            <div className="item right-side">
              <div className="bullet-container">
                <div className="bullet">
                  <div className="left-bullet-side">
                    <div className="sphere">
                      <span>1</span>
                    </div>
                  </div>
                  <div className="right-bullet-side">
                    <div className="bullet-title">
                      <Translate value="siteCeme_card1_bullet1_title" />
                    </div>
                    <div className="bullet-text">
                      <Translate value="siteCeme_card1_bullet1_text_1" />
                      <b>
                        <Translate value="siteCeme_card1_bullet1_text_2" />
                      </b>
                      <Translate value="siteCeme_card1_bullet1_text_3" />
                      <div className="store-links">
                        <a
                          href="https://play.google.com/store/apps/details?id=com.evio.evio&pli=1"
                          target="_blank"
                          rel="noreferrer"
                          onClick={() => requestMetaConversionAPI('android')}
                        >
                          <img src={GOOGLE} alt="Google" />
                        </a>
                        <a
                          href="https://apps.apple.com/pt/app/evio/id1539284689"
                          target="_blank"
                          rel="noreferrer"
                          onClick={() => requestMetaConversionAPI('ios')}
                        >
                          <img src={APPLE} alt="Apple" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bullet">
                  <div className="left-bullet-side">
                    <div className="sphere">
                      <span>2</span>
                    </div>
                  </div>
                  <div className="right-bullet-side">
                    <div className="bullet-title">
                      <Translate value="siteCeme_card1_bullet2_title" />
                    </div>
                    <div className="bullet-text">
                      <Translate value="siteCeme_card1_bullet2_text_1" />
                      <b>
                        <Translate value="siteCeme_card1_bullet2_text_2" />
                      </b>
                      <Translate value="siteCeme_card1_bullet2_text_3" />
                      <b>
                        <Translate value="siteCeme_card1_bullet2_text_4" />
                      </b>
                    </div>
                  </div>
                </div>

                <div className="bullet">
                  <div className="left-bullet-side">
                    <div className="sphere">
                      <span>3</span>
                    </div>
                  </div>
                  <div className="right-bullet-side">
                    <div className="bullet-title">
                      <Translate value="siteCeme_card1_bullet3_title" />
                    </div>
                    <div className="bullet-text">
                      <Translate value="siteCeme_card1_bullet3_text" />
                    </div>
                  </div>
                </div>

                <div className="bullet">
                  <div className="left-bullet-side">
                    <div className="sphere">
                      <span>4</span>
                    </div>
                  </div>
                  <div className="right-bullet-side">
                    <div className="bullet-title">
                      <Translate value="siteCeme_card1_bullet4_title" />
                    </div>
                    <div className="bullet-text">
                      <Translate value="siteCeme_card1_bullet4_text" />
                    </div>
                  </div>
                </div>

                <div className="bullet">
                  <div className="left-bullet-side">
                    <div className="sphere">
                      <span>5</span>
                    </div>
                  </div>
                  <div className="right-bullet-side">
                    <div className="bullet-title">
                      <Translate value="siteCeme_card1_bullet5_title" />
                    </div>
                    <div className="bullet-text">
                      <Translate value="siteCeme_card1_bullet5_text_1" />
                      <b>
                        <Translate value="siteCeme_card1_bullet5_text_2" />
                      </b>
                      <Translate value="siteCeme_card1_bullet5_text_3" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Card;
